import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Config } from '../../Config';

function Home() {
  useEffect(() => {
    window.location.href = 'https://doc.pro';
  }, []);

  return (
    <>
      <Helmet>
        <title>{Config?._AppName}</title>
      </Helmet>
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className='text-5xl md:text-6xl lg:text-8xl font-thin text-gray-500'>DocPro</h1>
      </div> 
    </>
  );
}

export default Home;
